import React from 'react';

const Program = () => {
    return (
        <div >
            <h3 className='tc'>DAFTAR PROGRAM PENDIDIKAN DI PKBM HANUBA MEDAN</h3>

            <div className="flex justify-center">
                <div className=" w-50 br3 pa3 mr2 bg-lightest-blue grow">
                    <h4 className='pl-3'>1. Paket A</h4>
                    <p className='pl-3'>Syarat:<br />
1. Photocopy Kartu Keluarga 3 lbr<br />
2. Photocopy Akta Lahir 2 lbr<br />
3. Pas photo 3 x 4 10 lbr</p>
                </div>
                <div className=" w-50 br3 pa3 mr2 bg-yellow grow">
                    <h4 className='pl-3'>2. Paket B</h4>
                    <p className='pl-3'>Syarat: <br />

                    1. Photocopy Ijazah SD ( Legalisir asli) 4 lbr<br />
2. Photocopy SKHU SD (Legalisir asli) 4 lbr<br />
3. Photocopy Kartu Keluarga 3 lbr<br />
4. Pas Photo 3 x 4 10 lbr
</p>
                </div>
            </div>


            
            <div className="flex justify-center">
                <div className=" w-50 br3 pa3 mr2 bg-light-green grow">
                    <h4 className='pl-3'>3. Paket C</h4>
                    <p className='pl-3'>Syarat:<br />
                    1. Photocopy Ijazah SMP ( Legalisir asli) 4 lbr<br/>
2. Photocopy SKHU SMP (Legalisir asli) 4 lbr<br/>
3. Photocopy Kartu Keluarga 3 lbr<br/>
4. Pas Photo 3 x 4 10 lbr
</p>
                </div>
                <div className=" w-50 br3 pa3 mr2 bg-hot-pink grow">
                    <h4 className='pl-3'>4. Program Menjahit</h4>
                    <p className='pl-3'>Syarat: <br />

                    1. Photocopy Kartu Keluarga 3 lbr<br/>
2. Photocopy KTP 3 lbr<br/>
3. Pas Photo 3 x 4 5 lbr<br/>
</p>
                </div>
            </div>

        </div>
    );
}

export default Program;